<template lang="pug">
    div
      .row
        //- .col.s12.right-align
        //-   a.btn.btn-flat(@click='showCreateInventory')
        //-     i.material-icons.left add
        //-     | New
        .col.s12
          //- ul.collection(v-if='inventories.length')
          //-   router-link.row.collection-item(v-for='inventory in inventories' :key='inventory.id' :to='{name: "inventory-details", params: {"inventoryName": inventory.name}}')
          //-     span.col.s10.m11.title.small {{inventory.name}}
          //-     a.col.s2.m1.btn.btn-flat(@click.prevent='showDeleteInventory(inventory)')
          //-       i.material-icons delete
          //- p.center.subtitle.small(v-else) Create an inventory to start selling
          ul.collection
            router-link.row.collection-item(:to='{name: "inventory-details", params: {"inventoryName": titleConventional }}')
              span.col.s10.m11.title.small Conventional
          ul.collection
            router-link.row.collection-item(:to='{name: "inventory-details", params: {"inventoryName": titleSMWS }}')
              span.col.s10.m11.title.small The Scotch Malt Whisky Society
          a.btn.btn-flat(@click='checksync') Sync Item

</template>
<script>
import AlertModalContent from 'inomph-common/dist/components/alert-modal-content'
import ModalCreateInventory from '@/components/modal-create-inventory'

export default {
  meta: {
    title: 'Inventory'
  },
  data () {
    return {
      inventories: [],
      titleConventional: 'Conventional',
      titleSMWS: 'The Scotch Malt Whisky Society'
    }
  },
  created () {
    this.getInventories()
  },
  computed: {
    supplier () {
      return this.$store.state.profile.supplier
    }
  },
  watch: {
    supplier () {
      this.getInventories()
    }
  },
  methods: {
    showCreateInventory () {
      const modalParams = {
        content: ModalCreateInventory,
        bind: {
          onAddSuccess: (inventory) => {
            this.inventories.push(inventory)
            this.$snackbar.success('Inventory added')
            this.$store.dispatch('modal/close')
          },
          onAddFailed: (err) => {
            this.$snackbar.error(err.message)
          }
        },
        style: {
          padding: 'medium'
        }
      }
      this.$store.dispatch('modal/open', modalParams)
    },
    showDeleteInventory (inventory) {
      const modalParams = {
        content: AlertModalContent,
        style: { padding: 'medium' },
        bind: {
          title: `Delete ${inventory.name}?`,
          message: 'This cannot be undone.',
          positiveButton: {
            message: 'Delete',
            onClick: this.confirmDeleteInventory.bind(this, inventory)
          },
          negativeButton: {
            message: 'Cancel',
            onClick: () => {
              this.$store.dispatch('modal/close')
            }
          }
        }
      }

      this.$store.dispatch('modal/open', modalParams).then(modal => {
        this.modal = modal
      })
    },
    confirmDeleteInventory (inventory) {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        this.$http.delete(`${this.$config.API_URL}/suppliers/${this.supplier.id}/inventories/${inventory.id}`, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        }).then(() => {
          this.$snackbar.success('Inventory deleted')
        }).catch(err => {
          this.$snackbar.error('Unable to delete inventory: ' + err.message)
        }).then(() => {
          this.getInventories()
          this.$store.dispatch('modal/close')
        })
      })
    },
    getInventories () {
      this.$store.dispatch('profile/getInventories').then(inventories => {
        this.inventories = inventories
      })
    },
    checksync () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        this.$http.get(`${this.$config.API_URL}/item/items/0`, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        }).catch(err => {
          this.$snackbar.error('Unable to delete inventory: ' + err.message)
        })
      })
    },
    postItem () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        this.$http.post(`${this.$config.API_URL}/item/updateinventory`, {
          itemID: '3700597343463',
          whseID: 'WHSE',
          qty: 2,
          acctCode: '1-00001'
        }, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        })
      }).catch(err => {
        this.$snackbar.error('Failed to connect, please try again.', err.message)
      })
    },
    addItem () {
      this.$store.dispatch('auth/getAccessToken').then(accessToken => {
        this.$http.post(`${this.$config.API_URL}/item/additem`, {
          'itemID': '99990002',
          'itemName': 'Test Item dev 99990002',
          'itemGroup': '142',
          'inventoryUOM': 'Bottles',
          'purchaseUOM': 'Bottles',
          'salesUOM': 'Bottles',
          'accountCode': '1-00001',
          'valMethod': '1',
          'status': '2'
        }, {
          headers: {
            authorization: `Bearer ${accessToken}`
          }
        })
      }).catch(err => {
        this.$snackbar.error('Failed to connect, please try again.', err.message)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-inventory-list.vue